//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from '~sdp-components/Header/Header'
import Navigation from '~/components/Navigation'
import SubNavigation from '~/components/Guardrail3Navigation'
import Footer from '~sdp-components/Footer/Footer'

export default {
  components: {
    Header,
    Navigation,
    SubNavigation,
    Footer,
  },
  computed: {
    print() {
      return this.$route.query.print === 'true' ?? false
    },
    bannerMessage() {
      return this.$store.state.bannerMessage
    },
  },
}
